import React, { createContext, useState, useEffect, ReactNode } from 'react';
import { KEY_AUTH } from '../utils/contants';

export interface AuthContextType {
  token: string | null;
  setSession: (newToken: string) => void;
  removeSession: () => void;
}

// Create Auth Context with a default value
export const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [token, setToken] = useState<string | null>(() => localStorage.getItem(KEY_AUTH));

  useEffect(() => {
    if (token) {
      localStorage.setItem(KEY_AUTH, token);
    } else {
      localStorage.removeItem(KEY_AUTH);
    }
  }, [token]);

  const setSession = (newToken: string) => {
    setToken(newToken);
    localStorage.setItem(KEY_AUTH, newToken); // Explicitly set token in localStorage
  };

  const removeSession = () => {
    setToken(null);
    localStorage.removeItem('token'); // Explicitly remove token from localStorage
  };

  return (
    <AuthContext.Provider value={{ token, setSession, removeSession }}>
      {children}
    </AuthContext.Provider>
  );
};
